module.exports = __webpack_public_path__ + "media/formula_gold.a7315fd1.mp4";